import React, { useState, useRef } from 'react';
import { SketchPicker } from 'react-color';

import { Typography, Box } from '@material-ui/core';
import propTypes from 'prop-types';

import { useOutsideClickCallback } from '../../../../hooks/use-outside-click-callback';
import {
  ColorPickerContainer,
  ColorBox,
  Divider,
  ColorPickerHeader,
} from './styles';

export function ColorPicker({ color, setColor, title }) {
  const [open, setOpen] = useState(false);
  const colorPickerRef = useRef(null);
  useOutsideClickCallback({ ref: colorPickerRef, cb: () => setOpen(false) });

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: open ? 'auto' : '150px',
      }}
    >
      <Typography
        style={{
          fontSize: '13px',
          marginBottom: '5px',
          color: '#616161',
          textAlign: 'center',
        }}
      >
        {title}
      </Typography>
      <ColorPickerContainer ref={colorPickerRef}>
        <ColorPickerHeader onClick={() => setOpen((prev) => !prev)}>
          <ColorBox color={color} />
          <Divider />
          <Typography style={{ fontSize: '13px', textTransform: 'uppercase' }}>
            {color}
          </Typography>
        </ColorPickerHeader>
        {open && (
          <>
            <Box sx={{ height: '10px' }} />
            <SketchPicker
              disableAlpha
              color={color}
              onChange={(color, event) => setColor(color.hex)}
            />
          </>
        )}
      </ColorPickerContainer>
    </Box>
  );
}

ColorPicker.propTypes = {
  color: propTypes.string.isRequired,
  setColor: propTypes.func.isRequired,
  title: propTypes.string,
};
